<template>
    <transition  >
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right float-left">
                        <ol class="breadcrumb m-0"> 
                            <li class="breadcrumb-item active">Settings</li>
                            <li class="breadcrumb-item"><a href="javascript: void(0);">Test Configuration Setup</a></li>
                            
                        </ol>
                    </div>
                    <div class="page-title-right float-right"> 
                        <button type="button" class="btn btn-primary float-right" @click="toggleModal()">
                            Add New
                        </button> 
                    </div>
                </div>
            </div>
        </div> 
        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :columns="columns" 
                            :sortKey="tableData.sortKey"  
                            @sort="sortBy" 
                            v-if="!loading">
                            <template #header > 
                                <div class="tableFilters" style="margin-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="control" style="float: left;">
                                                <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                <div class="select" style="float: left;">
                                                    <select class="form-select" v-model="tableData.length" @change="fetchDiagnosisTestConfigurationData()"> 
                                                        <option value="10" selected="selected">10</option>
                                                        <option value="25">25</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="500">500</option>
                                                        <option :value="pagination.total">All</option>
                                                    </select>
                                                </div>
                                                <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-2">
                                             
                                        </div>
                                        <div class="col-md-4">
                                            <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="fetchDiagnosisTestConfigurationData()">
                                        </div>
                                    </div>
                                </div>   
                            </template> 
                            <template #body >  
                                <tbody v-if="items.length > 0">
                                    <tr class="border" v-for="(item, i) in items" :key="i">
                                      
                                        <td class="text-center">{{ i + 1 }} </td>
                                        <td class="text-center">{{ item.name }}</td>
                                        <td class="text-center">{{ item.price }}</td> 
                                        <td class="text-center">{{ item.allocated_room }}</td>  
                                        <td class="text-center">
                                            <div class="dropdown float-end">
                                                <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i class="mdi mdi-dots-vertical"></i>
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">
                                                    <!-- item-->
                                                    <a href="javascript:void(0);" class="dropdown-item text-warning" @click="edit(item)"><i class="mdi mdi-circle-edit-outline"></i> Edit</a>
                                                    <a href="javascript:void(0);" class="dropdown-item text-danger" @click.prevent="deleteItem(item)"><i class="mdi mdi-delete-outline"></i> Remove</a>
                                                    <!-- item-->
                                                </div>
                                            </div>
                                        </td>
                                    </tr> 
                                </tbody> 
                                <tbody v-else>
                                    <tr>
                                        <td colspan="5"> No Data Available Here!</td>
                                    </tr>
                                </tbody>
                            </template> 
                            <template #footer>
                                <Pagination 
                                    :pagination="pagination"  
                                    :language="lang"
                                    @onChangePage="setPage" > 
                                </Pagination> 
                            </template> 
                        </Datatable>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row">
                                <div class="col-md-5"></div>
                                <div class="col-md-2">
                                    <img src="../../../assets/image/loading.gif" alt="Loading..." style="width: 130px;">
                                </div>
                                <div class="col-md-5"></div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        
        <!-- Modal -->
        <Modal @close="toggleModal()" :modalActive="modalActive">
            <div class="modal-content scrollbar-width-thin">
                <div class="modal-header"> 
                    <h3>Tests Configuration Add Or Edit</h3>
                    <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                </div>
                <form @submit.prevent="submitForm()" enctype="multipart/form-data">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="row">  
                                    <div class="col-md-12" v-if="editMode" style="pointer-events: none;">
                                        <label for="test_id" style="float: none;">Test Name *</label>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.test_id"
                                            placeholder="Select Test Name"  
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="testOptions"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false" 
                                            :create-option="true" 
                                            v-if="renderOptionComponent"
                                        />                                                   
                                        <div class="invalid-feedback" v-if="errors.test_id">
                                            {{errors.test_id[0]}}
                                        </div>
                                    </div>

                                    <div class="col-md-12" v-else>
                                        <label for="test_id" style="float: none;">Test Name *</label>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.test_id"
                                            placeholder="Select Test Name"  
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="testOptions"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false" 
                                            :create-option="true" 
                                            v-if="renderOptionComponent"
                                        />                                                   
                                        <div class="invalid-feedback" v-if="errors.test_id">
                                            {{errors.test_id[0]}}
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label for="allocated_room">Allocate Room *</label>
                                            <input type="text" class="form-control border " @keypress="onkeyPress('allocated_room')" v-model="form.allocated_room" id="allocated_room" placeholder="Write room number" autocomplete="off"> 
                                            <div class="invalid-feedback" v-if="errors.allocated_room">
                                                {{errors.allocated_room[0]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="row">
                                    <div class="wpr_table">
                                        <div class="general_wrapper">
                                            <div class="general_row_wrap">
                                                <div class="wpr_general_sign_title"> Reagent Items </div>
                                                <div class="wpr_general_row">
                                                    <div class="wpr_general_content">    
                                                        <!-- <table class="form-table wp-list-table widefat fixed striped mb-3 mt-3"> -->
                                                        <table class="table table-bordered table-centered">
                                                            <tbody class="wpr_thankyouorder_tbody">
                                                                <!-- Header Row -->
                                                                <tr valign="top" style="border-bottom: 2px solid #ddd; padding-bottom: 10px;">
                                                                    <th style="width: 20%;">Reagent</th>
                                                                    <th style="width: 10%;">Qty</th>
                                                                    <th style="width: 10%;">Price</th>
                                                                    <th style="width: 10%; text-align: center;">Action</th>
                                                                </tr> 

                                                                <!-- Item Rows  -->
                                                                <tr valign="top" v-for="(item, i) in form.reagent_items" :key="item.id">
                                                                    <td >
                                                                        <Multiselect 
                                                                            class="form-control border" 
                                                                            mode="single"
                                                                            v-model="item.reagent_id"
                                                                            placeholder="Select Reagent"  
                                                                            :searchable="true" 
                                                                            :filter-results="true"
                                                                            :options="reagentOptions"
                                                                            :classes="multiclasses"
                                                                            :close-on-select="true" 
                                                                            :min-chars="1"
                                                                            :resolve-on-load="false" 
                                                                            :create-option="true"
                                                                            @change="changeReagent($event, i)"
                                                                            v-if="renderOptionComponent"
                                                                        />  
                                                                    </td>
                                                                    <td >
                                                                        <label for="rqty_{{ i }}">
                                                                            <input type="text" id="rqty_{{ i }}" class="form-control" placeholder="Quantity"  
                                                                            v-model="item.qty">
                                                                        </label>
                                                                    </td>
                                                                    <td >
                                                                        <label for="price_{{ i }}">
                                                                            <input type="text" id="price_{{ i }}" class="form-control" placeholder="Price"  
                                                                            v-model="item.price">
                                                                        </label>
                                                                    </td>
                                                                    <td style="text-align: center; font-size: 18px !important;"> 
                                                                        <a href="javascript:void(0);" class="btn btn-danger btn-sm" style="margin-right: 5px;" @click="removeReagentItem(i)" title="Click to remove"><i class="fas fa-trash"></i></a>
                                                                        <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="addReagentItem(i)" title="Click to Add"><i class="fas fa-plus"></i></a>
                                                                    </td>  
                                                                </tr>

                                                            </tbody>
                                                        </table>                     
                                                    </div>
                                                </div>
                                                
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="wpr_table">
                                        <div class="general_wrapper">
                                            <div class="general_row_wrap">
                                                <div class="wpr_general_sign_title"> Inventory Stationary/Equipment Items </div>
                                                <div class="wpr_general_row">
                                                    <div class="wpr_general_content">    
                                                        <!-- <table class="form-table wp-list-table widefat fixed striped mb-3 mt-3"> -->
                                                        <table class="table table-bordered table-centered">
                                                            <tbody class="wpr_thankyouorder_tbody">
                                                                <!-- Header Row -->
                                                                <tr valign="top" style="border-bottom: 2px solid #ddd; padding-bottom: 10px;">
                                                                    <th style="width: 20%;">Name</th>
                                                                    <th style="width: 10%;">Qty</th>
                                                                    <th style="width: 10%;">Price</th>
                                                                    <th style="width: 10%; text-align: center;">Action</th>
                                                                </tr> 

                                                                <!-- Item Rows  -->
                                                                <tr valign="top" v-for="(item, i) in form.stequipment_items" :key="item.id">
                                                                    <td >
                                                                        <Multiselect 
                                                                            class="form-control border" 
                                                                            mode="single"
                                                                            v-model="item.product_id"
                                                                            placeholder="Select Equipment"  
                                                                            :searchable="true" 
                                                                            :filter-results="true"
                                                                            :options="stequipmentOptions"
                                                                            :classes="multiclasses"
                                                                            :close-on-select="true" 
                                                                            :min-chars="1"
                                                                            :resolve-on-load="false" 
                                                                            :create-option="true"
                                                                            @change="changeStequipment($event, i)"
                                                                            v-if="renderOptionComponent"
                                                                        />  
                                                                    </td>
                                                                    <td >
                                                                        <label for="isqty_{{ i }}">
                                                                            <input type="text" id="isqty_{{ i }}" class="form-control" placeholder="Quantity"  
                                                                            v-model="item.qty">
                                                                        </label>
                                                                    </td>
                                                                    <td >
                                                                        <label for="price_{{ i }}">
                                                                            <input type="text" id="price_{{ i }}" class="form-control" placeholder="Price"  
                                                                            v-model="item.price">
                                                                        </label>
                                                                    </td>
                                                                    <td style="text-align: center; font-size: 18px !important;"> 
                                                                        <a href="javascript:void(0);" class="btn btn-danger btn-sm" style="margin-right: 5px;" @click="removeStEquipmentItem(i)" title="Click to remove"><i class="fas fa-trash"></i></a>
                                                                        <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="addStEquipmentItem(i)" title="Click to Add"><i class="fas fa-plus"></i></a>
                                                                    </td>   
                                                                </tr>

                                                            </tbody>
                                                        </table>                     
                                                    </div>
                                                </div>
                                                
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="wpr_table">
                                        <div class="general_wrapper">
                                            <div class="general_row_wrap">
                                                <div class="wpr_general_sign_title"> Expense Head Items </div>
                                                <div class="wpr_general_row">
                                                    <div class="wpr_general_content">    
                                                        <!-- <table class="form-table wp-list-table widefat fixed striped mb-3 mt-3"> -->
                                                        <table class="table table-bordered table-centered">
                                                            <tbody class="wpr_thankyouorder_tbody">
                                                                <!-- Header Row -->
                                                                <tr valign="top" style="border-bottom: 2px solid #ddd; padding-bottom: 10px;">
                                                                    <th style="width: 20%;">Expense Head</th>
                                                                    <th style="width: 10%;">Qty</th>
                                                                    <th style="width: 10%;">Amount</th>
                                                                    <th style="width: 10%; text-align: center;">Action</th>
                                                                </tr> 

                                                                <!-- Item Rows  -->
                                                                <tr valign="top" v-for="(item, i) in form.expense_items" :key="item.id">
                                                                    <td >
                                                                        <Multiselect 
                                                                            class="form-control border" 
                                                                            mode="single"
                                                                            v-model="item.expense_head_id"
                                                                            placeholder="Select Expense Items"  
                                                                            :searchable="true" 
                                                                            :filter-results="true"
                                                                            :options="expenseOptions"
                                                                            :classes="multiclasses"
                                                                            :close-on-select="true" 
                                                                            :min-chars="1"
                                                                            :resolve-on-load="false" 
                                                                            :create-option="true"
                                                                            v-if="renderOptionComponent"
                                                                        />  
                                                                    </td>
                                                                    <td>
                                                                        <label for="eqty_{{ i }}">
                                                                            <input type="text" id="eqty_{{ i }}" class="form-control" placeholder="Quantity"  
                                                                            v-model="item.qty">
                                                                        </label>
                                                                    </td>
                                                                    <td>
                                                                        <label for="amount_{{ i }}">
                                                                            <input type="text" id="amount_{{ i }}" class="form-control" placeholder="Amount"  
                                                                            v-model="item.amount">
                                                                        </label>
                                                                    </td>
                                                                    <td style="text-align: center; font-size: 18px !important;"> 
                                                                        <a href="javascript:void(0);" class="btn btn-danger btn-sm" style="margin-right: 5px;" @click="removeExpenseItem(i)" title="Click to remove"><i class="fas fa-trash"></i></a>
                                                                        <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="addExpenseItem(i)" title="Click to Add"><i class="fas fa-plus"></i></a>
                                                                    </td>  
                                                                </tr>

                                                            </tbody>
                                                        </table>                     
                                                    </div>
                                                </div>
                                                
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer"> 
                        <button type="button" class="btn btn-danger" @click="toggleModal()">
                            Close
                        </button>
                        <button type="submit" class="btn btn-primary " :disabled="disabled">
                            <span v-show="isSubmit">
                                <i class="fas fa-spinner fa-spin" ></i>
                            </span>{{btn}} 
                        </button>
                        
                    </div>
                </form>
            </div>
        </Modal>
    </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';

import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { reference } from "@popperjs/core";

export default {
    name: 'PosLeftbar',
    components: {
        Modal,
        Datatable,
        Pagination
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: false,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            imagePreview:'',
            btn:'Create',
            renderOptionComponent: true,
            items: [],
            reagent_items: [],
            reagentOptions: [],
            stequipment_items: [],
            stequipmentOptions: [],
            expense_items: [],
            expenseOptions: [],
            test_items: [],
            testOptions:[],
            form: new Form({
                id: '',
                test_id: '',
                allocated_room: '',
                reagent_items: [
                    {reagent_id: '', qty: '', price: ''}
                ],
                stequipment_items: [
                    {product_id: '', qty: '', price: ''}
                ],
                expense_items: [
                    {expense_head_id: '', qty: '', amount: ''}
                ],
            }),
            multiclasses: { 
              clear: '',
              clearIcon: '', 
            }, 
            columns: [ 
                {
                    label: 'SL',
                    name: '',           
                    width: '5%'
                },  
                {
                    label: 'Test Name',
                    name: 'test_id',           
                    width: '15%'
                },
                {
                    label: 'Price',
                    name: 'price',
                    width: '15%'
                },
                {
                    label: 'Allocated Room',
                    name: 'allocated_room',           
                    width: '15%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '5%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 1,
                // dir: 'desc',
                dir: 'asc',
                sortKey: 'name', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }, 
        };
    },
    created() {
        this.fetchDiagnosisTestConfigurationData();
    },
    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();
        },

        fetchDiagnosisTestConfigurationData(url = this.apiUrl+'/hm/diagnosis_test_configuration_setup') { 
            this.forceRerender();
            this.tableData.draw++;
            axios.get(url, {params:this.tableData, headers:this.headerparams}) 
            .then((res) => {
                let data = res.data.data;   
                console.log('datazxsv', data);
                if(this.tableData.draw = data.draw) { 
                  this.items = data.data.data;
                  this.configPagination(data.data);
                }

                this.test_items = data.test_data;
                this.testOptions = data.test_data.map((item) => {
                    return { label: item.name, value: item.id }
                });
                this.reagent_items = data.reagent_data;
                this.reagentOptions = data.reagent_data.map((item) => {
                    return { label: item.product_name, value: item.id }
                });
                this.stequipment_items = data.inv_stequipment_data;
                this.stequipmentOptions = data.inv_stequipment_data.map((item) => {
                    return { label: item.product_name, value: item.id }
                });

                this.expense_items = data.expense_head_data;
                this.expenseOptions = data.expense_head_data.map((item) => {
                    return { label: item.name, value: item.id }
                });


            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                //this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.fetchDiagnosisTestConfigurationData();
        },
        setPage(data){  
            this.fetchDiagnosisTestConfigurationData(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        filterData(){
          this.fetchDiagnosisTestConfigurationData(); 
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item);  
        },
        submitForm: function(e) { 

            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();   
            formData.append('id', this.form.id);
            formData.append('test_id', this.form.test_id);
            formData.append('allocated_room', this.form.allocated_room);
            formData.append('reagent_items', JSON.stringify(this.form.reagent_items)); //this.form.reagent_items);
            formData.append('stequipment_items', JSON.stringify(this.form.stequipment_items)); //this.form.stequipment_items);
            formData.append('expense_items', JSON.stringify(this.form.expense_items)); //this.form.expense_items);
            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/hm/diagnosis_test_configuration_setup/'+this.form.id, formData, this.headers);
            }else{ 
                // this.form.image ? formData.append('image', this.form.image, this.form.image.name) : '';
                var postEvent = axios.post(this.apiUrl+'/hm/diagnosis_test_configuration_setup', formData, this.headers);
            }  

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.fetchDiagnosisTestConfigurationData();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            });
        },
        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/diagnosis_test_configuration_setup/'+item.id,this.headers) 
                    .then(res => {
                        if(res.status == 200){  
                            this.fetchDiagnosisTestConfigurationData();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                        console.log(res.data)
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },


        /* Add Reagent Items */
        addReagentItem: function (row_index) {
            if(this.form.reagent_items.length == row_index+1 && this.form.reagent_items.length < this.reagent_items.length){
                const newObj = {reagent_id:'', qty:'', price:''}
                this.form.reagent_items.push(newObj);
            }
        },
        removeReagentItem: function (row_index) {
            if(this.form.reagent_items.length > 1){    
                this.form.reagent_items.splice(row_index, 1);
            }
        },

        changeReagent: function(reagent_id, i){
            let ritem = this.reagent_items.find((ritem) => {return ritem.id == reagent_id});
            this.form.reagent_items[i].price = ritem.cost_price;
        },

        addStEquipmentItem: function (row_index) {
            if(this.form.stequipment_items.length == row_index+1 && this.form.stequipment_items.length < this.stequipment_items.length){  
                const newObj = {product_id:'', qty:'', price:''}
                this.form.stequipment_items.push(newObj);
            }
        },
        removeStEquipmentItem: function (row_index) {
            if(this.form.stequipment_items.length > 1){    
                this.form.stequipment_items.splice(row_index, 1);
            }
        },

        changeStequipment: function(product_id, i){
            let sitem = this.stequipment_items.find((sitem) => {return sitem.id == product_id});
            this.form.stequipment_items[i].price = sitem.cost_price;
        },

        /* Add Expense Items */
        addExpenseItem: function (row_index) {
            if(this.form.expense_items.length == row_index+1 && this.form.expense_items.length < this.expense_items.length){   
                const newObj = {expense_id:'', amount:''}
                this.form.expense_items.push(newObj);
            }
        },
        removeExpenseItem: function (row_index) {
            if(this.form.expense_items.length > 1) {
                this.form.expense_items.splice(row_index, 1);
            }
        }

    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
    .modal-content.scrollbar-width-thin {
        border: none !important;
        width: 900px;
    }

    label {
        display: inline-block;
        margin: 0px 0px 4px 2px;
        float: left;
    }

    .invalid-feedback {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
        text-align: left;
    }


    /* Reagent Items */
    #mwb_rwpr_setting_wrapper * {
        box-sizing: border-box;
    }

    .mwb_rwpr_content_template {
        box-shadow: -2px 0 5px -1px rgba(0, 0, 0, .05);
        color: #555d66;
        font-size: 16px;
        flex: 0 0 80%;
        padding: 10px 30px 10px 40px;
        position: relative;
        line-height: 28px;
    }

    #mwb_rwpr_setting_wrapper * {
        box-sizing: border-box;
    }

    #mwb_rwpr_setting_wrapper * {
        box-sizing: border-box;
    }

    #mwb_rwpr_setting_wrapper * {
        box-sizing: border-box;
    }

    .general_row_wrap {
        box-shadow: 2px 3px 20px rgba(0, 0, 0, .2);
        /* margin: 20px 0 40px 0; */
    }

    .mwb_rwpr_content_template {
        color: #555d66;
        font-size: 16px;
        line-height: 28px;
    }

    .wpr_general_sign_title {
        width: 100%;
        display: block;
        padding: 8px 20px;
        background-color: #4f3154;
        display: block;
        color: #fff;
        font-weight: 700;
        font-size: 18px;
    }

    .wpr_general_row {
        display: flex;
        flex-wrap: wrap;
        padding: 0 10px;
        align-items: center;
    }

    .wpr_general_sign_title {
        width: 100%;
        display: block;
        padding: 8px 20px;
        background-color: #4f3154;
        display: block;
        color: #fff;
        font-weight: 700;
        font-size: 18px;
    }

    #mwb_rwpr_setting_wrapper * {
        box-sizing: border-box;
    }

    .wpr_general_label label {
        width: 150px;
        display: inline-block;
    }

    .wpr_general_label {
        width: 210px;
        font-weight: 600;
    }

    .wpr_general_content {
        width: 100%;
        padding: 15px;
    }

    .wpr_general_content,
    .wpr_general_label {
        padding: 13px 0;
    }
</style>